// src/pages/PipelineCandidats.jsx

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { pipelineAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

import {
  Search,
  RefreshCw,
  Plus,
  Filter,
  LayoutGrid,
  List,
  X,
  UserCheck
} from 'lucide-react';

import './Kanban.css';
import CandidateCard from '../components/candidates/CandidateCard';
import PipelineCandidatesListView from '../components/candidates/PipelineCandidatesListView';

const STATUS_CONFIG = {
 /* NOUVEAU:      { label: 'Nouveau',      kanbanColor: '#3B82F6' },
  EN_COURS:     { label: 'En cours',     kanbanColor: '#F59E0B' },
  CONTACTE:     { label: 'Contacté',     kanbanColor: '#A78BFA' },
  ENTRETIEN:    { label: 'Entretien',    kanbanColor: '#06B6D4' },
  PROPOSE:      { label: 'Proposé',      kanbanColor: '#EA580C' },
  PLACE:        { label: 'Placé',        kanbanColor: '#16A34A' },
  STAFFE:       { label: 'Staffé',       kanbanColor: '#22C55E' },
  ARCHIVE:      { label: 'Archivé',      kanbanColor: '#6B7280' },
  REFUSE:       { label: 'Refusé',       kanbanColor: '#DC2626' },
  NON_QUALIFIE: { label: 'Non qualifié', kanbanColor: '#991B1B' },
  BLACK_LISTE:  { label: 'Blacklisté',   kanbanColor: '#111827' }*/

  /*CV_IMPLEMENTE: { label: 'CV implémenté', kanbanColor: '#F59E0B' },
  PAS_A_LECOUTE: { label: 'Pas à l’écoute', kanbanColor: '#6B7280' },
  QUALIFICATION_EN_COURS: { label: 'Qualification', kanbanColor: '#A78BFA' },
  SOFT_SKILLS:{   label: 'Soft Skills',    kanbanColor:'#3bbbf6'},
  HARD_SKILLS: {    label: 'Hard Skills',    kanbanColor: '#3B82F6'},
  VALIDE: { label: 'Validé', kanbanColor: '#16A34A' },
  NON_QUALIFIE: { label: 'Non qualifié', kanbanColor: '#DC2626' }*/

  CV_IMPLEMENTE: { label: 'CV implémenté', kanbanColor: '#F59E0B' },
  PAS_A_LECOUTE: { label: 'Pas à l’écoute', kanbanColor: '#6B7280' },
  QUALIFICATION_EN_COURS: { label: 'Qualification en cours', kanbanColor: '#A78BFA' },
  VALIDE: { label: 'Validé', kanbanColor: '#16A34A' }
};

const SOURCE_META = {
  MANUEL:     { label: 'Manuel', color: '#6B7280' },
  SHORTLIST:  { label: 'Shortlist', color: '#8B5CF6' },
  TOP_PROFIL: { label: 'Top Profil', color: '#EA580C' },
  IMPORT:     { label: 'Import CV', color: '#3B82F6' }
};

/*const COLUMNS = [
  'NOUVEAU',
  'EN_COURS',
  'CONTACTE',
  'ENTRETIEN',
  'PROPOSE',
  'PLACE',
  'STAFFE',
  'ARCHIVE',
  'REFUSE',
  'NON_QUALIFIE',
  'BLACK_LISTE'
];*/
const COLUMNS = Object.keys(STATUS_CONFIG);
export default function PipelineCandidats() {

  const navigate = useNavigate();
  const { user } = useAuth();

  const [loading, setLoading] = useState(true);
  const [entries, setEntries] = useState([]);

  const [search, setSearch] = useState('');

const [filters, setFilters] = useState({
  source_type: '',
  priority: '',
  favorite: '',
  manager: ''
});

  const [viewMode, setViewMode] = useState('kanban');

  const canAdd =
    ['ADMIN',
      'SUPER_ADMIN',
      'BUSINESS_MANAGER',
      'TALENT_ACQUISITION',
      'INGENIEUR_AFFAIRES']
      .includes((user?.role || '').toUpperCase());

  const fetchData = useCallback(async () => {

    setLoading(true);

    try {

      const params = {
        limit: 10000
      };

      if (search)
        params.search = search;

      if (filters.source_type)
        params.source_type = filters.source_type;

      if (filters.priority)
        params.priority = filters.priority;

      if (filters.favorite)
        params.favorite = true;

      const res = await pipelineAPI.list(params);


      setEntries(res.data || []);
    } catch {

      toast.error("Erreur chargement pipeline");

    } finally {

      setLoading(false);

    }

 

  }, [search, filters]);

  useEffect(() => {

    fetchData();

  }, [fetchData]);


/** ajout soft and hard skills */
/*const getPipelineColumn = (candidate) => {
  const sourceType = candidate.source_type?.toUpperCase() || "";

  if (sourceType.includes("SOFT")) {
    return "SOFT_SKILLS";
  }

  if (sourceType.includes("HARD")) {
    return "HARD_SKILLS";
  }

  return candidate.pipeline_status || "CV_IMPLEMENTE";
};*/

/** simplification du kanban : CV implémenté / Pas à l'écoute / Qualification en cours / Validé
 *  Soft Skills, Hard Skills et Non qualifié sont regroupés dans "Qualification en cours"
 */
const getPipelineColumn = (candidate) => {
  const sourceType = candidate.source_type?.toUpperCase() || "";
  const status = candidate.pipeline_status?.toUpperCase() || "";

  // Soft/Hard skills viennent du source_type -> fusionnés
  if (sourceType.includes("SOFT") || sourceType.includes("HARD")) {
    return "QUALIFICATION_EN_COURS";
  }

  // Non qualifié fusionné dans Qualification en cours
  if (status === "NON_QUALIFIE") {
    return "QUALIFICATION_EN_COURS";
  }

  // Pas à l'écoute reste sa propre colonne
  if (status === "PAS_A_LECOUTE") {
    return "PAS_A_LECOUTE";
  }

  if (status === "VALIDE") {
    return "VALIDE";
  }

  if (status === "QUALIFICATION_EN_COURS") {
    return "QUALIFICATION_EN_COURS";
  }

  return "CV_IMPLEMENTE";
};

  /*const board = useMemo(() => {

    const map = {};

    COLUMNS.forEach(col => {

      map[col] = entries.filter(
        e => (e.pipeline_status || 'NOUVEAU') === col
      );

    });

    return map;

  }, [entries]);*/


const filteredEntries = useMemo(() => {
  if (!filters.manager) return entries;
  return entries.filter(e => e.manager_name === filters.manager);
}, [entries, filters.manager]);


 const board = useMemo(() => {
  const map = {};
  COLUMNS.forEach(col => {
    map[col] = filteredEntries.filter(
      e => getPipelineColumn(e) === col
    );
  });
  return map;
}, [filteredEntries]);

const managerOptions = useMemo(() => {
  const set = new Set();
  entries.forEach(e => { if (e.manager_name) set.add(e.manager_name); });
  return [...set].sort((a, b) => a.localeCompare(b));
}, [entries]);



  return (

    <div className="kanban-shell">

      <div className="page-header">

        <div className="page-header-left">
          <h1>Pipeline candidats</h1>
          <p>Suivi des profils candidats</p>
        </div>

        <div className="page-header-actions">

          <div className="view-toggle">

            <button
              className={`view-toggle-btn ${viewMode === 'kanban' ? 'active' : ''}`}
              onClick={() => setViewMode('kanban')}
            >
              <LayoutGrid size={15} />
            </button>

            <button
              className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
            >
              <List size={15} />
            </button>

          </div>

          <button
            className="btn btn-secondary"
            onClick={fetchData}
          >
            <RefreshCw size={15} />
          </button>

          {canAdd && (

            <button
              className="btn btn-success"
              onClick={() => navigate('/pipeline/new')}
            >
              <Plus size={15} />
              Nouveau profil
            </button>

          )}

        </div>

      </div>

      <div className="filters-bar">

        <div className="filter-search">

          <Search size={15} />

          <input
            placeholder="Rechercher un candidat..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

        </div>

        <select
          className="filter-select"
          value={filters.source_type}
          onChange={e =>
            setFilters(f => ({
              ...f,
              source_type: e.target.value
            }))
          }
        >

          <option value="">Toutes sources</option>

          {Object.entries(SOURCE_META).map(([k, v]) => (

            <option
              key={k}
              value={k}
            >
              {v.label}
            </option>

          ))}

        </select>

        <select
          className="filter-select"
          value={filters.priority}
          onChange={e =>
            setFilters(f => ({
              ...f,
              priority: e.target.value
            }))
          }
        >

          <option value="">Toutes priorités</option>
          <option value="HAUTE">Haute</option>
          <option value="NORMALE">Normale</option>
          <option value="BASSE">Basse</option>

        </select>
<select
  className="filter-select"
  value={filters.manager}
  onChange={e =>
    setFilters(f => ({
      ...f,
      manager: e.target.value
    }))
  }
>
  <option value="">Tous responsables</option>
  {managerOptions.map(m => (
    <option key={m} value={m}>{m}</option>
  ))}
</select>

<button
  className="btn btn-secondary"
  onClick={() =>
    setFilters({
      source_type: '',
      priority: '',
      favorite: '',
      manager: ''
    })
  }
>
  <X size={14} />
  Réinitialiser
</button>
       

      </div>

      {loading ? (

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: 50
          }}
        >
          <div className="spinner" />
        </div>

      ) : viewMode === 'kanban' ? (

        <div className="kanban-board">

          {COLUMNS.map(colKey => {

            const cfg = STATUS_CONFIG[colKey];

            const items = board[colKey] || [];

            return (

              <div
                className="kanban-col"
                key={colKey}
              >

                <div className="kanban-col-header">

                  <div
                    className="kanban-col-dot"
                    style={{
                      background: cfg.kanbanColor
                    }}
                  />

                  <span className="kanban-col-title">
                    {cfg.label}
                  </span>

                  <span className="kanban-col-count">
                    {items.length}
                  </span>

                </div>

                <div className="kanban-cards">

                  {items.length === 0 &&
                    <div className="kanban-empty">
                      Aucun profil
                    </div>
                  }

                  {items.map(candidate => (

                    <CandidateCard
                      key={candidate.id}
                      candidate={candidate}
                      color={cfg.kanbanColor}
                    />

                  ))}

                </div>

              </div>

            );

          })}

        </div>

      ) : (

       <PipelineCandidatesListView
  entries={filteredEntries}
/>

      )}

    </div>

  );

}